import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import accounting from 'accounting';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import ConfirmationCard from '../../components/Shared/ConfirmationCard';
import { Title as DefaultTitle } from '../../components/Shared/TitleSuccess';

import { setOverlayPartnerVisible } from '../Widget/actions.js';
import { copyFor } from '../../copy/copy';

const Title = DefaultTitle.extend`
    span {
        font-weight: 800;
        color: #ff245e;
        cursor: pointer;
    }
`;

const TitleComponent = props => (
    <Title
        onClick={e => props.setOverlayPartnerVisible(true, e, false)}
        dangerouslySetInnerHTML={{
            __html: copyFor('feedback', 'donated', 'donation', undefined, {
                amountFormated: props.amountFormated,
                partnerName: `<span id="partnerName">${props.partnerName}</span>`
            })
        }}
    />
);

TitleComponent.propTypes = {
    amountFormated: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired
};

const DonationSuccess = props => (
    <TransitionContainer>
        <ConfirmationCard
            rightAlign
            peopleCount={props.peopleCount}
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent
                    amountFormated={props.amountFormated}
                    partnerName={props.partnerName}
                    setOverlayPartnerVisible={props.setOverlayPartnerVisible}
                />
            }
            {...props}
        />
    </TransitionContainer>
);

DonationSuccess.propTypes = {
    peopleCount: PropTypes.string.isRequired,
    thankYouText: PropTypes.string.isRequired,
    amountFormated: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired
};

export default connect(
    state => ({
        peopleCount:
            state.donation.completeDonation !== undefined
                ? state.donation.completeDonation.endUsersCount
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                : '',
        thankYouText: state.donation.successInfo.feedbackText || '',
        amountFormated: accounting.formatMoney(state.donation.selectedAmount, '$', 0),
        partnerName: state.donation.successInfo.partnerName
    }),
    {
        setOverlayPartnerVisible
    }
)(DonationSuccess);



// WEBPACK FOOTER //
// ./src/containers/Donation/DonationSuccess.jsx